import type { Bcp47Locale, Locale } from '@backmarket/http-api'
import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

export const languagesDict: { [localePrefix: string]: string } = {
  fr: 'Français',
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
  fi: 'Suomi',
  el: 'Ελληνικά',
  ja: '日本語',
  nl: 'Nederlands',
  pt: 'Português',
  sv: 'Svenska',
  sk: 'Slovenčina',
}

export function countryDisplayNameLocale(
  locale: Locale,
  countryCode: MarketCountryCode,
) {
  const localePrefix = locale.split('_')[0]
  const language = languagesDict[localePrefix] || ''

  return `${language} (${countryCode})`
}

export function countryDisplayNameBcp47(
  locale: Bcp47Locale,
  countryCode: MarketCountryCode,
) {
  const localePrefix = locale.split('-')[0]
  const language = languagesDict[localePrefix] || ''

  return `${language} (${countryCode})`
}
